import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { questionTypeEnum } from '@configs/ai.config';
import { QuestionSubTypeIdEnum } from '@configs/questions.config';
import { AiGenerateService } from '@services/ai.generate.service';
import { ItemService } from '@services/item.service';
import { NotificationService } from '@services/notification.service';
import { QuestionService } from '@services/question.service';
import { Subscription } from 'rxjs';
import { AddStrategyComponent } from '../add-Strategy/add-Strategy.component';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-ai-generated-questions',
  templateUrl: './ai-generated-questions.component.html',
  styleUrls: ['./ai-generated-questions.component.scss'],
  providers: [AiGenerateService]
})
export class AiGeneratedQuestionsComponent implements OnInit {
  private reuseProp = {
    questionuuId: 'questionuuId',
    questiondescription: 'questiondescription',
    description: 'description',
    tempStem: 'tempStem',
    tempOption: 'tempOption',
    stems: 'stems',
    options: 'options',
    correctPoints: 'correctPoints',
    itemId: 'itemId',
    penaltyPoints: 'penaltyPoints',
    minScoreIfAttempt: 'minScoreIfAttempt',
    scoringTypeExactMatch: 'scoringTypeExactMatch',
    maximumcharacterForFreetext: 'maximumcharacterForFreetext'
  }
  public display: boolean = false;
  public listDisplay: boolean = false;

  FactorRules: boolean = true;
  selectedOption: any = 'Sample question';
  @Input() questionTypeName: any;
  @Input() questionType: any;
  @Input() questionSubTypeId: any;
  questionTypes = questionTypeEnum;
  @Output() postCreated = new EventEmitter();
  QuestionSubTypeIdEnum = QuestionSubTypeIdEnum;

  @ViewChild('standardStrategy') standardStrategy: AddStrategyComponent;
  private itemId: number;
  private itemBankId: string

  public userForm: FormGroup;
  public questionForm: FormGroup;
  defultvalueScore = 0;
  submitted = false;
  strategyData: any[] = [];
  disableOptionCount: boolean = false;
  data: any;
  newEvent = 0;
  minOption: number = 0;
  selected: any = 0;
  success: number = 0;
  count: number = 0;
  orientation = [];
  scoringType= [];

  constructor(
    private aiGenerateService: AiGenerateService,
    private questionService: QuestionService,
    private routerstate: ActivatedRoute,
    private notificationService: NotificationService,
    private itemservice: ItemService,
    private webErrorService: WebErrorService,
    public translate: TranslateService,
    ) { }

  ngOnInit(): void {
    this.routerstate?.parent?.params?.subscribe((data) => { this.itemBankId = data.id; });
    this.itemId = parseInt(sessionStorage.getItem('itemId'));
    this.questionForm = this.generateQuestionForm();
    this.userForm = new FormGroup({ questionArray: new FormArray([]) });

    if (this.questionSubTypeId == QuestionSubTypeIdEnum.FillInTheBlanks) {
      this.minOption = 0;
      this.questionForm.get('optionCount').setValue(0);
    } else {
      this.minOption = 2;
      this.questionForm.get('optionCount').setValue(2);
    }

    this.questionService.getQuestionOrientation().subscribe(res => {
      this.orientation = res.data;
    });
    this.questionService.getQuestionScoringType().subscribe(res => {
     this.scoringType = res.data;
    })
  }
  // ------------ Form Generation ----------------
  generateQuestionForm() {
    return new FormGroup({
      itemStrategy: new FormControl('sample_question'),
      referenceText: new FormControl('', [Validators.required]),
      numberOfQuestions: new FormControl(0, [Validators.required, Validators.min(1)]),
      optionCount: new FormControl(0, [Validators.required, Validators.min(1)]),
      responseCount: new FormControl(0, [Validators.required]),
      enableTags: new FormControl(false),
      numberOfBlank: new FormControl(0)
    })
  }

  generateUserForm(data: any) {
    return new FormGroup({
      [this.reuseProp.options]: new FormArray([]),
      [this.reuseProp.stems]: new FormControl([]),
      [this.reuseProp.questiondescription]: new FormGroup({
        description: new FormControl(data.question),
        mediaURL: new FormControl(["String"])
      }),
      answer: new FormControl(),
      [this.reuseProp.itemId]: new FormControl(this.itemId),
      autoScoring: new FormControl('true'),
      shuffleOption: new FormControl(false),
      // [this.reuseProp.correctPoints]: new FormControl(0),
      [this.reuseProp.correctPoints]: new FormControl({ value: 0, disabled: true }),
      active: new FormControl(true),
      ansRenderCount: new FormControl(0),
      questionOrder: new FormControl(0),
      questionSubTypeId: new FormControl(0),
      questionTypeId: new FormControl(0),
      allowCheckAnswer: new FormControl(false),
      questiondisplayoptions: new FormControl('Vertical'),
      [this.reuseProp.scoringTypeExactMatch]: new FormControl('true'),
      [this.reuseProp.minScoreIfAttempt]: new FormControl(0),
      [this.reuseProp.penaltyPoints]: new FormControl(0),
      [this.reuseProp.maximumcharacterForFreetext]: new FormControl(0),
      isSelected: new FormControl(false),
      newEvent: new FormControl(0),
      isAIGenerated: new FormControl(false),
      answerDescription: new FormGroup({
        description: new FormControl(this.questionSubTypeId === QuestionSubTypeIdEnum.Descriptive ? data.answer : ''),
        mediaURL: new FormControl([""])
      }),
      correctAns: new FormControl(false)
    })
  }

  generateOptions(data: any, index: number, number: number) {
    return new FormGroup({
      id: new FormControl(0),
      answerDescription: new FormGroup({
        description: new FormControl(data.question),
        mediaURL: new FormControl([""])
      }),
      answerValid: new FormControl(!!data.answerValid),
      arrangeOrder: new FormControl(index),
      correctPoints: new FormControl(0),
      modified: new FormControl(false),
      optionId: new FormControl(index),
      // optionId: new FormControl(this.questionSubTypeId === QuestionSubTypeIdEnum.FillInTheBlanks ? 1 : index + 1),
      selected: new FormControl(false),
      questionNumber: new FormControl(number)
    })
  }

  onCheck() {
    if (this.questionSubTypeId == QuestionSubTypeIdEnum.MultipleChoiceOptions) {
      if (this.questionForm.get('responseCount').value > this.questionForm.get('optionCount').value) {
        this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestAiDriven.errMsg1'), true, 'warn')
        this.questionForm.controls['responseCount'].setErrors({'incorrect': true});
        return;
      }
    }
  }
  // ------------ Add Critearea Generation ----------------
  removeStrategy(index: number) {
    this.strategyData.splice(index, 1)
    this.setReferenceText(this.strategyData);
  }

  resetStrategy() {
    this.strategyData = [];
    this.questionForm.get('referenceText').setValue("");
  }

  addStrategy() {
    this.standardStrategy.showPopup();
    const strategySubscription: Subscription = this.standardStrategy.onClose.subscribe((resp) => {
      this.strategyData.push(resp);
      this.setReferenceText(this.strategyData);
      strategySubscription.unsubscribe();
    });
  }

  setReferenceText(strategyData) {
    if (strategyData && strategyData.length) {
      const itemStatagy: any[] = []
      this.strategyData.forEach(element => { itemStatagy.push(`${element.StrategyName} : ${element.value}`) });
      this.questionForm.get('referenceText').setValue(itemStatagy.join(', '));
    } else {
      this.questionForm.get('referenceText').setValue("");
    }
  }

  onCheckRadioOption(questions, question) {
    questions.forEach((element) => {
      if (element.value.optionId === question.value.optionId) {
        element.patchValue({ answerValid: true });
      } else {
        element.patchValue({ answerValid: false });
      }
    });
    this.addScore(questions, question);
  }

  addScore(questions, question) {
    const scoreArray = [];
    questions.forEach((element) => {
      if (element.get('answerValid').value) {
        scoreArray.push(element.get('correctPoints').value);
      }
    });
    if (scoreArray && scoreArray.length) {
      this.userForm.get('questionArray')['controls'][question.get('questionNumber').value - 1].patchValue({ newEvent: scoreArray.reduce(add, 0) })
      function add(accumulator, a) {
        return accumulator + a;
      }
    }
  }

  addScoreForFIB(questions, index: number) {
    const scoreArray = [];
    questions.forEach((element) => {
      if (element.get('answerValid').value) {
        scoreArray.push(element.get('correctPoints').value);
      }
    });
    if (scoreArray && scoreArray.length) {
      this.userForm.get('questionArray')['controls'][index].patchValue({ newEvent: scoreArray.reduce(add, 0) });
      function add(accumulator, a) {
        return accumulator + a;
      }
    }
  }

  toggleCheckbox() {
    this.selected = this.userForm.value.questionArray.filter(d => d.isSelected);
  }

  addQuestions() {
    if (!!this.itemId) {
      const selectedOption = this.userForm.value.questionArray.filter(d => d.isSelected);
      if (selectedOption && selectedOption.length) {

        for (var data of selectedOption) {
          const validateAnswer = data.options.filter(d => d.answerValid);

          if ((validateAnswer && validateAnswer.length == 0) && this.questionSubTypeId != QuestionSubTypeIdEnum.Descriptive) {
            this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestAiDriven.errMsg2'), true, 'warn')
            return;
          }

          if ((data.correctPoints == 0 || data.correctPoints == null) && this.questionSubTypeId === QuestionSubTypeIdEnum.Descriptive) {
            this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestAiDriven.errMsg3'), true, 'warn')
            return;
          }

          if ((data.maximumcharacterForFreetext == 0 || data.maximumcharacterForFreetext == null) && this.questionSubTypeId === QuestionSubTypeIdEnum.Descriptive) {
            this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestAiDriven.errMsg4'), true, 'warn')
            return;
          }

          if (data.minScoreIfAttempt > ((data.correctPoints != 0 && data.correctPoints != undefined) ? data.correctPoints : data.newEvent)) {
            this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestAiDriven.errMsg5'), true, 'warn')
            return;
          }
        }
        this.itemservice.itemQCount.subscribe(e=>{
          this.count  = e;
        });

        selectedOption.forEach(async (element, index) => {
          element.questionSubTypeId = this.questionType;
          element.questionOrder = index + 1;
          if (element.minScoreIfAttempt == null) element.minScoreIfAttempt = 0;
          if (this.count == 0) {
            element.questionCount = index + 1;
          } else {
            element.questionCount = this.count + 1;
            this.count = element.questionCount;
          }

          const validateAnswer = element.options.filter(d => d.answerValid);
          if ((validateAnswer && validateAnswer.length) || this.questionSubTypeId === QuestionSubTypeIdEnum.Descriptive) {
            element.scoringTypeExactMatch = JSON.parse(element.scoringTypeExactMatch)
            element.questionTypeId = this.questionType;
            element.questionSubTypeId = this.questionSubTypeId;
            element.isAIGenerated = true;
            element.correctPoints = (element.correctPoints != 0 && element.correctPoints != undefined) ? element.correctPoints : element.newEvent;
            if (this.questionSubTypeId === QuestionSubTypeIdEnum.FillInTheBlanks) {
              const data = { ...element, questiondescription: { description: this.prepareQuestion(element.questiondescription.description), mediaURL: [""] } };
              var { isSelected, newEvent, answerDescription, ...payload } = data;
            } else {
              var { isSelected, newEvent, ...payload } = element;
            }
            this.questionService
              .addQuestion(payload, this.itemBankId)
              .subscribe(
                (resData) => {
                  if (resData.success && this.success == 0) {
                    this.success = 1;
                    this.notificationService.success(resData?.message); // This line used to display message
                    this.itemservice.questionCountUpdate.next(true);
                    this.questionService.reloadList.next(true);
                    this.listDisplay = true;
                    this.back();
                  }
                }, (error: any) => {
                  this.webErrorService.handleAPIErrors(error, null, true, 'warn');
                });
          } else {
            this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestAiDriven.errMsg2'), true, 'warn')
          }
        });
      } else {
        this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestAiDriven.errMsg6'), true, 'warn')
      }
    }
  }

  prepareQuestion(question: string): string {
    let preparedQuestion = '';
    let added: boolean = false;
    let answerCount = 1;
    const splitted = question.split('_');
    if (splitted && splitted.length) {
      if (!splitted[0]) {
        preparedQuestion += ` Answer${answerCount} `;
        answerCount += 1;
      }
      splitted.forEach(item => {
        if (item) {
          preparedQuestion += item;
          added = true;
        } else {
          if (added) {
            preparedQuestion += ` Answer${answerCount} `;
            answerCount += 1;
            added = false;
          }
        }
      });
      if (preparedQuestion.indexOf('Answer') === -1) {
        preparedQuestion += ` Answer${answerCount} `;
      }
    }
    return preparedQuestion;
  }

  back() {
    this.postCreated.emit('false');
    this.display = true;
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 ||(k >= 48 && k <= 57) ||  k == 46);
  }

  replace2Decimal(event: any, o, type: any){
    let value = event.target.value;
    if (event.key == '.') value = value + event.key; // appended . to the value
    if(value == '.') value = "";
    var ponto = value.split('.').length;

    if (ponto > 2) value = value.substr(0, (value.length)-1);

    value = value.replace(/[^0-9.-]/,'');

    if (ponto == 2) value = value.substr(0,(value.indexOf('.')+3));  // if you enter 3 digits after . (20.764), you will get only 2 digit (20.76)

    if (type == 'options') {
      o.correctPoints = parseFloat(value);
      this.userForm.get('questionArray')['controls'].correctPoints = parseFloat(value);
    }
    if (type == 'minimumScore') {
      let num = value.substr(value.length - 1);
      if (num != '.' && value != '') this.userForm.controls.minimumScoreIfAttempt.setValue(parseFloat(value))
    }
  }

  generateQuestion() {
    if (this.userForm.get('questionArray').value.length) {
      (this.userForm.get('questionArray') as FormArray).clear();
    }
    switch (this.questionSubTypeId) {
      case QuestionSubTypeIdEnum.MultipleChoiceStandard:
        this.generateSingleChoiceMultipleQuestion();
        break;
      case QuestionSubTypeIdEnum.MultipleChoiceOptions:
        this.generateMultipleMultiChoiceOption();
        break;
      case QuestionSubTypeIdEnum.MultipleChoiceYesOrNo:
        this.generateMultipleBooleanChoiceOption();
        break;
      case QuestionSubTypeIdEnum.Descriptive:
        this.generateFreeTextAnswerChoiceOption();
        break;
      case QuestionSubTypeIdEnum.FillInTheBlanks:
        this.generateFillInTheBlanksQuestion();
        break;
    }
  }

  generateQuestionForDescriptive(resp) {
    resp.forEach(element => {
      (this.userForm.get('questionArray') as FormArray).push(this.generateUserForm(element));
    });
  }

  generateSingleChoiceMultipleQuestion() {
    const { answerDescription, ...payload } = this.questionForm.value;
    const generateQuestion: Subscription = this.aiGenerateService.singleChoiceMultipleResponse(payload).subscribe((data) => {
      if (data && data.data && data.data.items && data.data.items.length) {
        this.generateQuestions(data.data.items);
      }
    }, () => { }, () => { generateQuestion.unsubscribe(); });
  }

  generateMultipleMultiChoiceOption() {
    const { answerDescription, ...payload } = this.questionForm.value;
    const generateQuestion: Subscription = this.aiGenerateService.multipleMultipleResponse(payload).subscribe((data) => {
      if (data && data.data && data.data.items && data.data.items.length) {
        this.generateQuestions(data.data.items);
      }
    }, () => { }, () => { generateQuestion.unsubscribe(); });
  }

  generateMultipleBooleanChoiceOption() {
    const { responseCount, answerDescription, optionCount, ...payload } = this.questionForm.value;
    const generateQuestion: Subscription = this.aiGenerateService.booleanMultipleResponse(payload).subscribe((data) => {
      if (data && data.data && data.data.items && data.data.items.length) {
        this.generateQuestions(data.data.items);
      }
    }, () => { }, () => { generateQuestion.unsubscribe(); });
  }

  generateFreeTextAnswerChoiceOption() {
    const { responseCount, answerDescription, optionCount, ...payload } = this.questionForm.value;
    const generateQuestion: Subscription = this.aiGenerateService.freeTextAnswer(payload).subscribe((data) => {
      if (data && data.data && data.data.items && data.data.items.length) {
        this.generateQuestions(data.data.items);
      }
    }, () => { }, () => { generateQuestion.unsubscribe(); });
  }

  generateFillInTheBlanksQuestion() {
    const { answerDescription, ...payload } = this.questionForm.value;
    const generateQuestion: Subscription = this.aiGenerateService.fillInTheBlank(payload).subscribe((data) => {
      if (data && data.data && data.data.items && data.data.items.length) {
        this.generateFillInTheBlanks(data.data.items);
      }
    }, () => { }, () => { generateQuestion.unsubscribe(); });
  }

  generateFillInTheBlanks(data: any) {
    data.forEach((resp) => {
      (this.userForm.get('questionArray') as FormArray).push(this.generateUserForm(resp));
      resp.answer.forEach((option, findIndex) => {
        (this.userForm.get('questionArray')['controls'][this.userForm.get('questionArray').value.length - 1].get([this.reuseProp.options]) as FormArray).push(this.generateOptions({ question: option, answerValid: true }, findIndex + 1, findIndex + 1))
        // option.forEach((o: any, optIndex: number) => {
        //   if (o === resp.answer.find(a => a === o)) { (this.userForm.get('questionArray')['controls'][this.userForm.get('questionArray').value.length - 1].get([this.reuseProp.options]) as FormArray).push(this.generateOptions({ question: o, answerValid: true }, optIndex + 1, findIndex + 1)) };
        // })
      });
    });
  }


  generateQuestions(data: any) {
    data.forEach((resp, index) => {
      (this.userForm.get('questionArray') as FormArray).push(this.generateUserForm(resp));
      if (resp.options && resp.options.length && this.questionSubTypeId !== QuestionSubTypeIdEnum.Descriptive) {
        this.userForm.get('questionArray')['controls'][this.userForm.get('questionArray').value.length - 1]['controls']['correctPoints'].disable();
        resp.options.forEach((question, findIndex) => {
          if (this.questionSubTypeId !== QuestionSubTypeIdEnum.MultipleChoiceStandard && this.questionSubTypeId !== QuestionSubTypeIdEnum.MultipleChoiceYesOrNo || this.questionSubTypeId === QuestionSubTypeIdEnum.FillInTheBlanks) {
            if (resp.answer && resp.answer.length && resp.answer.find(d => d === question)) {
              (this.userForm.get('questionArray')['controls'][this.userForm.get('questionArray').value.length - 1].get([this.reuseProp.options]) as FormArray).push(this.generateOptions({ question: question, answerValid: true }, findIndex + 1, index + 1))
            } else {
              (this.userForm.get('questionArray')['controls'][this.userForm.get('questionArray').value.length - 1].get([this.reuseProp.options]) as FormArray).push(this.generateOptions({ question: question }, findIndex + 1 , index + 1))
            }
          }
          if (this.questionSubTypeId === QuestionSubTypeIdEnum.MultipleChoiceStandard || this.questionSubTypeId === QuestionSubTypeIdEnum.MultipleChoiceYesOrNo) {
            if (resp.answer && resp.answer.length && resp.answer === question) {
              (this.userForm.get('questionArray')['controls'][this.userForm.get('questionArray').value.length - 1].get([this.reuseProp.options]) as FormArray).push(this.generateOptions({ question: question, answerValid: true }, findIndex + 1, index + 1));
              // this.userForm.get('questionArray')['controls'][this.userForm.get('questionArray').value.length - 1].patchValue({ correctAns: true })
            } else {
              (this.userForm.get('questionArray')['controls'][this.userForm.get('questionArray').value.length - 1].get([this.reuseProp.options]) as FormArray).push(this.generateOptions({ question: question }, findIndex + 1, index + 1))
            }
          }
        });
      } else {
        this.userForm.get('questionArray')['controls'][this.userForm.get('questionArray').value.length - 1]['controls']['correctPoints'].enable();
      }
    });
  }

  reset() {
    this.questionForm = this.generateQuestionForm();
    if (this.questionSubTypeId == QuestionSubTypeIdEnum.FillInTheBlanks) {
      this.minOption = 0;
      this.questionForm.get('optionCount').setValue(0);
    } else {
      this.minOption = 2;
      this.questionForm.get('optionCount').setValue(2);
    }
    (this.userForm.get('questionArray') as FormArray).clear();
  }

  validateInput(event, o?, type?) {
    const inputElement = event.target;
    const value = inputElement.value;

    const regex = /^\d{0,4}(\.\d{0,2})?$/;
    const inputVal = inputElement.value.split('.')
    const beforeDecimal = inputVal[0]
    const afterDecimal = inputVal[1]
    console.log('value',value)
    if (!regex.test(value)) {
      inputElement.value = value.slice(0, -1);
      if (type == 'options') o.patchValue({ correctPoints: parseFloat(inputElement.value ) });
      if (type == 'minimumScore') o.patchValue({ minScoreIfAttempt: parseFloat(inputElement.value) });

      if (beforeDecimal.length == 5 && afterDecimal.length > 1){
        inputElement.value = ''
        if (type == 'options') o.patchValue({ correctPoints: 0 });
        if (type == 'minimumScore') o.patchValue({ minScoreIfAttempt: 0 });
      }
    }
  }
}
function lastValueFrom(arg0: any) {
  throw new Error('Function not implemented.');
}

